const generateQueryString = (params: Record<string, boolean | number | string>): string =>
    Object.keys(params).reduce<string>((acc, key, index) => {
        const queryString = `${key}=${encodeURIComponent(params[key])}`

        return index === 0 ? `?${queryString}` : `${acc}&${queryString}`
    }, '')

export { generateQueryString }
